if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
        this.messageInput.addEventListener('input', this.updateCharacterLimit.bind(this))
        this.setMinMaxDate()
      }

      updateCharacterLimit(e) {
        const maxChar = e.target.maxLength
        const messageLength = this.messageInput.value.length
        this.querySelector('.js-remaining-characters').textContent = maxChar - messageLength
      }

      formatDate(date) {
        const yyyy = date.getFullYear();
        const mm = (date.getMonth() + 1).toString().padStart(2, '0');
        const dd = date.getDate().toString().padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
      }

      setMinMaxDate() {
        const today = new Date();
        const maxDate = new Date(today);

        maxDate.setDate(today.getDate() + 90);

        const minInput = document.querySelector('.js-date-limit');

        if (minInput) {
          minInput.setAttribute('min', this.formatDate(today));
          minInput.setAttribute('max', this.formatDate(maxDate));
        }
      }
    }
  )
}